import { Button, ExternalLink, InternalLink, Line, ModalBody, ModalHeader, P } from "@sorcery/ui";

import { useModal } from "~/providers/ModalProvider";
import { collectionGuidePath } from "~/utils/paths";

export const PrintoutCollectionTrackersModal = () => {
  const { closeModal } = useModal();

  return (
    <div className="p-6">
      {/* header */}
      <ModalHeader title="Printout Collection Trackers" />

      <ModalBody>
        {/* item */}
        <div className="mb-2 w-full">
          <P>
            <span>
              These are available for those that prefer the oldschool style. For a more modern
              experience, see our
            </span>{" "}
            <InternalLink href={collectionGuidePath} color="primary">
              Digital Collection Tracker guide.
            </InternalLink>
          </P>
          <Line className="mb-4" />

          <ExternalLink
            target="_blank"
            href="https://d27a44hjr9gen3.cloudfront.net/assets/checklists/ArthurianLegends-CollectionChecklist.pdf"
          >
            <P className="hover:text-primary !mb-0 transition-colors">- Arthurian Legends (A4)</P>
          </ExternalLink>
          <ExternalLink
            target="_blank"
            href="https://d27a44hjr9gen3.cloudfront.net/assets/checklists/ArthurianLegends-CollectionChecklist-USLetter.pdf"
          >
            <P className="hover:text-primary !mb-0 transition-colors">- Arthurian Legends (USL)</P>
          </ExternalLink>

          <ExternalLink
            target="_blank"
            href="https://d27a44hjr9gen3.cloudfront.net/assets/checklists/CollectionChecklist-Beta.pdf"
          >
            <P className="hover:text-primary !mb-0 transition-colors">- Beta (A4)</P>
          </ExternalLink>
          <ExternalLink
            target="_blank"
            href="https://d27a44hjr9gen3.cloudfront.net/assets/checklists/CollectionChecklist-Beta-USletter.pdf"
          >
            <P className="hover:text-primary !mb-0 transition-colors">- Beta (USL)</P>
          </ExternalLink>

          <ExternalLink
            target="_blank"
            href="https://d27a44hjr9gen3.cloudfront.net/assets/checklists/CollectionChecklist-Alpha-A4.pdf"
          >
            <P className="hover:text-primary !mb-0 transition-colors">- Alpha (A4)</P>
          </ExternalLink>
          <ExternalLink
            target="_blank"
            href="https://d27a44hjr9gen3.cloudfront.net/assets/checklists/CollectionChecklist-Alpha-USletter.pdf"
          >
            <P className="hover:text-primary !mb-0 transition-colors">- Alpha (USL)</P>
          </ExternalLink>
        </div>
      </ModalBody>

      {/* footer */}
      <Line />
      <div className="flex flex-row-reverse pt-4 gap-2">
        <Button onClick={closeModal} variant="secondary">
          Close
        </Button>
      </div>
    </div>
  );
};
